import { useLocale } from '@solinkcorp/locale';
import { TextLogo } from '@solinkcorp/solink-ui/assets/assets';
import { Link } from 'react-router-dom';
import { useControllerState } from 'solox';
import { type Controller } from '../../../Controller';
import { useDarkMode } from '../../DarkMode/useDarkMode';
import { LayoutSelector } from '../LayoutSelector/LayoutSelector';
import { VerticalDivider } from './Header';

const HeaderLeft = (props: { controller: Controller; canEdit: boolean }) => {
  const { controller, canEdit } = props;
  const locale = useLocale();

  const darkMode = useDarkMode();
  const isEditing = useControllerState(controller.state, (state) => !!state.editingLayout);
  const layoutName = useControllerState(
    controller.state,
    (state) => state.editingLayout?.name ?? '',
  );

  return (
    <>
      <span className="flex items-center gap-4">
        <Link to={'/'}>
          <img
            src={darkMode ? TextLogo.dark : TextLogo.light}
            className="w-34 h-8 max-h-8 min-w-32"
            data-testid="solink-logo"
          />
        </Link>{' '}
        <VerticalDivider />
        {isEditing ? (
          <p className="text-xs font-semibold uppercase tracking-tighter text-foreground-secondary">
            {layoutName
              ? locale.serviceDisplayMonitor.editing.replace('{{layoutName}}', layoutName)
              : locale.serviceDisplayMonitor.creatingNewLayout}
          </p>
        ) : (
          <LayoutSelector controller={controller} canEdit={canEdit} />
        )}
      </span>
    </>
  );
};

export default HeaderLeft;
